export default "__VITE_ASSET__CFy2tcKs__"